import config from '@/config';
import api from '@/shared/api';

// Dedupe concurrent requests per relation; no stale cache because streams can be
// added/removed on the relation file while the app is running.
const inFlight = new Map();

export const getInvoiceStreamNames = (relationId, forInvoice = false) => {
  if (!relationId) return Promise.resolve([]);
  if (inFlight.has(relationId)) return inFlight.get(relationId);

  const promise = api.base
    .get(`${config.appUrls.api}/api/invoiceStream/Names/${relationId}`, {
      params: { forInvoice: forInvoice || undefined },
    })
    .then(({ data }) => data || [])
    .finally(() => inFlight.delete(relationId));

  inFlight.set(relationId, promise);
  return promise;
};

export const getInvoiceStreamNamesBulk = relationIds => {
  if (!relationIds || !relationIds.length) return Promise.resolve({});
  return api.base
    .post(`${config.appUrls.api}/api/invoiceStream/Names`, relationIds)
    .then(({ data }) => data || {});
};

export default {
  getInvoiceStreamNames,
  getInvoiceStreamNamesBulk,
};
